(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core"], factory);
	else if(typeof exports === 'object')
		exports["mbc-legend"] = factory(require("mbc-core"));
	else
		root["mbc-legend"] = factory(root["mbc-core"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_39__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 186);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var shared = __webpack_require__(35);
var hasOwn = __webpack_require__(6);
var uid = __webpack_require__(47);
var NATIVE_SYMBOL = __webpack_require__(46);
var USE_SYMBOL_AS_UID = __webpack_require__(52);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(2);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toObject = __webpack_require__(16);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isObject = __webpack_require__(5);

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(53);
var anObject = __webpack_require__(8);
var toPropertyKey = __webpack_require__(22);

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(33);
var requireObjectCoercible = __webpack_require__(21);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getOwnPropertyDescriptor = __webpack_require__(41).f;
var createNonEnumerableProperty = __webpack_require__(13);
var redefine = __webpack_require__(18);
var setGlobal = __webpack_require__(25);
var copyConstructorProperties = __webpack_require__(70);
var isForced = __webpack_require__(69);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var definePropertyModule = __webpack_require__(9);
var createPropertyDescriptor = __webpack_require__(20);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__(61);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var requireObjectCoercible = __webpack_require__(21);

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var hasOwn = __webpack_require__(6);
var createNonEnumerableProperty = __webpack_require__(13);
var setGlobal = __webpack_require__(25);
var inspectSource = __webpack_require__(26);
var InternalStateModule = __webpack_require__(44);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(42).CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__(71);
var isSymbol = __webpack_require__(43);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var userAgent = __webpack_require__(59);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var setGlobal = __webpack_require__(25);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var isCallable = __webpack_require__(2);
var store = __webpack_require__(24);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var wellKnownSymbol = __webpack_require__(4);
var V8_VERSION = __webpack_require__(23);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var classof = __webpack_require__(32);

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(17);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var isCallable = __webpack_require__(2);
var classofRaw = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var fails = __webpack_require__(3);
var classof = __webpack_require__(17);

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(55);
var store = __webpack_require__(24);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isObject = __webpack_require__(5);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(22);
var definePropertyModule = __webpack_require__(9);
var createPropertyDescriptor = __webpack_require__(20);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var fails = __webpack_require__(3);
var isArray = __webpack_require__(31);
var isObject = __webpack_require__(5);
var toObject = __webpack_require__(16);
var lengthOfArrayLike = __webpack_require__(15);
var createProperty = __webpack_require__(38);
var arraySpeciesCreate = __webpack_require__(48);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(4);
var V8_VERSION = __webpack_require__(23);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var call = __webpack_require__(12);
var propertyIsEnumerableModule = __webpack_require__(67);
var createPropertyDescriptor = __webpack_require__(20);
var toIndexedObject = __webpack_require__(10);
var toPropertyKey = __webpack_require__(22);
var hasOwn = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(53);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var hasOwn = __webpack_require__(6);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getBuiltIn = __webpack_require__(14);
var isCallable = __webpack_require__(2);
var isPrototypeOf = __webpack_require__(54);
var USE_SYMBOL_AS_UID = __webpack_require__(52);

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(74);
var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var isObject = __webpack_require__(5);
var createNonEnumerableProperty = __webpack_require__(13);
var hasOwn = __webpack_require__(6);
var shared = __webpack_require__(24);
var sharedKey = __webpack_require__(45);
var hiddenKeys = __webpack_require__(27);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(35);
var uid = __webpack_require__(47);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(23);
var fails = __webpack_require__(3);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(77);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var redefine = __webpack_require__(18);
var toString = __webpack_require__(80);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var tryToString = __webpack_require__(64);

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);
var classof = __webpack_require__(32);
var getBuiltIn = __webpack_require__(14);
var inspectSource = __webpack_require__(26);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(46);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var fails = __webpack_require__(3);
var createElement = __webpack_require__(36);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var hasOwn = __webpack_require__(6);
var toIndexedObject = __webpack_require__(10);
var indexOf = __webpack_require__(76).indexOf;
var hiddenKeys = __webpack_require__(27);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(83);
var uncurryThis = __webpack_require__(1);
var IndexedObject = __webpack_require__(33);
var toObject = __webpack_require__(16);
var lengthOfArrayLike = __webpack_require__(15);
var arraySpeciesCreate = __webpack_require__(48);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__(50);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(37);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(8);
var defineProperties = __webpack_require__(90);
var enumBugKeys = __webpack_require__(37);
var hiddenKeys = __webpack_require__(27);
var html = __webpack_require__(91);
var documentCreateElement = __webpack_require__(36);
var sharedKey = __webpack_require__(45);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DOMIterables = __webpack_require__(78);
var DOMTokenListPrototype = __webpack_require__(79);
var forEach = __webpack_require__(86);
var createNonEnumerableProperty = __webpack_require__(13);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var toString = __webpack_require__(30);
var regexpFlags = __webpack_require__(87);
var stickyHelpers = __webpack_require__(92);
var shared = __webpack_require__(35);
var create = __webpack_require__(63);
var getInternalState = __webpack_require__(44).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(102);
var UNSUPPORTED_NCG = __webpack_require__(103);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__(6);
var ownKeys = __webpack_require__(75);
var getOwnPropertyDescriptorModule = __webpack_require__(41);
var definePropertyModule = __webpack_require__(9);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var isObject = __webpack_require__(5);
var isSymbol = __webpack_require__(43);
var getMethod = __webpack_require__(60);
var ordinaryToPrimitive = __webpack_require__(73);
var wellKnownSymbol = __webpack_require__(4);

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var isCallable = __webpack_require__(2);
var isObject = __webpack_require__(5);

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var inspectSource = __webpack_require__(26);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);
var uncurryThis = __webpack_require__(1);
var getOwnPropertyNamesModule = __webpack_require__(62);
var getOwnPropertySymbolsModule = __webpack_require__(68);
var anObject = __webpack_require__(8);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isArray = __webpack_require__(31);
var isConstructor = __webpack_require__(51);
var isObject = __webpack_require__(5);
var wellKnownSymbol = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(36);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var classof = __webpack_require__(32);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var FUNCTION_NAME_EXISTS = __webpack_require__(42).EXISTS;
var uncurryThis = __webpack_require__(1);
var defineProperty = __webpack_require__(9).f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(37);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var aCallable = __webpack_require__(50);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var isArray = __webpack_require__(31);
var isConstructor = __webpack_require__(51);
var isObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);
var toIndexedObject = __webpack_require__(10);
var createProperty = __webpack_require__(38);
var wellKnownSymbol = __webpack_require__(4);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);
var un$Slice = __webpack_require__(88);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var uncurryThis = __webpack_require__(1);
var IndexedObject = __webpack_require__(33);
var toIndexedObject = __webpack_require__(10);
var arrayMethodIsStrict = __webpack_require__(58);

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(57).forEach;
var arrayMethodIsStrict = __webpack_require__(58);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

module.exports = uncurryThis([].slice);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var exec = __webpack_require__(66);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var definePropertyModule = __webpack_require__(9);
var anObject = __webpack_require__(8);
var toIndexedObject = __webpack_require__(10);
var objectKeys = __webpack_require__(82);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);
var createProperty = __webpack_require__(38);

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var $filter = __webpack_require__(57).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 98 */
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toIntegerOrInfinity = __webpack_require__(19);
var toString = __webpack_require__(30);
var requireObjectCoercible = __webpack_require__(21);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(89);
var uncurryThis = __webpack_require__(1);
var redefine = __webpack_require__(18);
var regexpExec = __webpack_require__(66);
var fails = __webpack_require__(3);
var wellKnownSymbol = __webpack_require__(4);
var createNonEnumerableProperty = __webpack_require__(13);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(100).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var anObject = __webpack_require__(8);
var isCallable = __webpack_require__(2);
var classof = __webpack_require__(17);
var regexpExec = __webpack_require__(66);

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var classof = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(4);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(34);
var toIntegerOrInfinity = __webpack_require__(19);
var lengthOfArrayLike = __webpack_require__(15);
var toObject = __webpack_require__(16);
var arraySpeciesCreate = __webpack_require__(48);
var createProperty = __webpack_require__(38);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var TypeError = global.TypeError;
var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(98);
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(104);
var isRegExp = __webpack_require__(110);
var anObject = __webpack_require__(8);
var requireObjectCoercible = __webpack_require__(21);
var speciesConstructor = __webpack_require__(118);
var advanceStringIndex = __webpack_require__(105);
var toLength = __webpack_require__(61);
var toString = __webpack_require__(30);
var getMethod = __webpack_require__(60);
var arraySlice = __webpack_require__(95);
var callRegExpExec = __webpack_require__(106);
var regexpExec = __webpack_require__(66);
var stickyHelpers = __webpack_require__(92);
var fails = __webpack_require__(3);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var aConstructor = __webpack_require__(119);
var wellKnownSymbol = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isConstructor = __webpack_require__(51);
var tryToString = __webpack_require__(64);

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(188);

var _legend = _interopRequireDefault(__webpack_require__(189));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _legend.default;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(84);

__webpack_require__(49);

__webpack_require__(65);

__webpack_require__(40);

__webpack_require__(81);

__webpack_require__(97);

var core = __webpack_require__(39);

var Utils = core.Utils;
var Classes = core.Classes;
var mbc_mds_constants = Utils.colors.mbc_mds_constants;
var mbc_mds_space = mbc_mds_constants['space'];
var mbc_mds_size_icon = mbc_mds_constants['size']['icon'];

var drawSVG = __webpack_require__(190);

var icon_mds_ellipsis_circle_s = __webpack_require__(191);

function Legend() {}
/**
 * @class Legend
 * instantiates legend object with necessary variable and constants
 * defaultOptions consistent across charts unless otherwise defined in specific chart
 * @param options Contains any chart specific options declared in chart
 */


Legend.prototype.invokeLegend = function (options) {
  var canvas = this.get('canvas'),
      _this = this;

  options = options || {};
  this.__OPTIONS = options;
  var defaultOptions = {
    container: this.get('selection').select('.' + Classes.LEGEND),
    legend: this.get('selection').select('.' + Classes.LEGEND).select(".".concat(Classes.LEGEND, "-inner")),
    data: this.get('data'),
    benchmark: this.get('data').get('benchmark'),
    benchmarkColor: this.get('benchmarksColor') || this.get('benchmarkColor'),
    benchmarkStyle: false,
    benchmarkSpan: 'benchmark',
    mouseover: true
  };
  Utils.object.copy(defaultOptions, options);
  this._options = defaultOptions; // Variables

  this._canvas = canvas;
  if (this._isBubbleChart() && !this._options.container[0][0].parentElement) return;
  var parentClassList = this._options.container[0][0].parentElement.classList;
  var arr = [].slice.call(parentClassList);
  arr.forEach(function (pClass, idx) {
    if (pClass.indexOf('mbc_') >= 0) {
      _this.set('parentID', pClass);
    }
  });
  var parentID = this.get('parentID');
  this._container = this._options.container.attr('id', "svgcontainer_".concat(parentID));
  this._data = this._options.data;
  this._legend = this._options.legend;
  this._benchmarkColor = this._options.benchmarkColor;
  this._benchmarkStyle = this._options.benchmarkStyle;
  this._benchmarkSpan = this._options.benchmarkSpan;
  this._margin = canvas.get('margin');
  this._legendTitle = this.get('legendTitle');
  this._benchmarkLabel = this.get('benchmarkLabel');
  this._legendMaxWidth = this.get('legendMaxWidth');
  var id = "mbc-mds-popover--".concat(this.generateID());

  if (this.get('popoverID') == null) {
    _this.set('popoverID', id);
  }

  this._createLegend();
};
/**
 * @method _createLegend
 * Create legend div container
 * Includes the title
 */


Legend.prototype._createLegend = function () {
  var parentID = this.get('parentID');

  var _this = this;

  if (this._options.chart === 'horizontalBar') {
    var child = this._container[0][0].children;
    var arr = [].slice.call(child);

    if (typeof arr !== 'undefined') {
      arr.forEach(function (gElem) {
        gElem.parentElement.removeChild(gElem);
      });
    }

    _this.get('selection').select('.mbc-chart-legend').append('div').attr('class', "".concat(Classes.LEGEND, "-container"));

    this._container.style({
      'margin-left': this._canvas.get('margin').left + 'px',
      'margin-right': '30px',
      'margin-top': this._canvas.get('margin').top + 'px',
      'margin-bottom': '-30px'
    });

    if (this._options.orient === 'top') this._container.style({
      'margin-bottom': -20 + 'px'
    });
    if (this._options.orient === 'bottom') this._container.style({
      'margin-bottom': -30 + 'px'
    });
  } else {
    if (this._isScatterPlot()) {
      var child = this._container[0][0].children;
      var arr = [].slice.call(child);

      if (typeof arr !== 'undefined') {
        arr.forEach(function (gElem) {
          gElem.parentNode.removeChild(gElem);
        });
      }
    } else {
      this._legend.remove();
    }

    this._setLegendHeightWidth();

    this.getDottedLines();
  }

  if (this._isVerticalBar() || this._options.chart === 'lineChart' || this._options.chart === 'time-series' || this._options.chart === 'horizontalBar' || this._isScatterPlot() || this._isBubbleChart()) {
    var id = this.get('popoverID');
    var iconBtn = document.getElementsByClassName('mbc-mds-popover__trigger');
    var child = this._container[0][0].parentElement.children;
    var arr = [].slice.call(child);
    arr.forEach(function (div) {
      d3.select(div).attr('popoverID', id);
    });
    this.makeSVGContainer();
    this.drawSVGLegend();
    if (this._options.chart !== 'horizontalBar') this.adjustLegendWidth(parseFloat(d3.select("#svgcontainer_".concat(parentID)).select('svg').attr('width')));
    if (iconBtn != null && iconBtn.length > 0) this.setPopoverPosition(id);

    if ((this._isScatterPlot() || this._isBubbleChart()) && this._container[0][0].hasChildNodes() && this._container[0][0].childNodes.length > 1 && this._container.classed(Classes.LEGEND + '-right')) {
      var borderWeight = 1; // Border style is 1px in weight

      var noOffset = 0;
      var legendTitleDefaultHeight = 14; // Default legend title is one line with height 14px

      var legendTitle = this._container[0][0].childNodes[0];
      var legendTitleHeight = legendTitle.getBoundingClientRect().height;
      var legendTitleMargin = parseInt(window.getComputedStyle(legendTitle).marginBottom, 10);

      if (!this._legendTitle) {
        legendTitleHeight = 0;
        legendTitleMargin = 0;
      }

      var legendContainerPadding = parseInt(window.getComputedStyle(this._container[0][0]).paddingTop, 10);

      if (this._isScatterPlot()) {
        var chartLayerHeight = this._canvas.layer('y-axis', 'axes')[0][0].getBoundingClientRect().height; // Subtract the border weight when the legend title wraps


        var legenTitleMaxWidth = parseInt(legendTitle.style.maxWidth.slice(0, -2), 10);
        var legendTitleWidth = legendTitle.getBoundingClientRect().width;
        var borderOffset = legendTitleWidth == legenTitleMaxWidth ? noOffset : borderWeight;
        var legendHeight = chartLayerHeight - legendTitleHeight - legendTitleMargin - legendContainerPadding - borderOffset * 2;

        if (!this._legendTitle) {
          legendHeight = legendHeight + borderOffset * 2;
        }

        d3.select(this._container[0][0]).style('height', chartLayerHeight + 'px');
        d3.select(this._container[0][0].childNodes[1]).style('height', legendHeight + 'px');
      }

      if (this._isBubbleChart()) {
        // Subtract the extra height due to legend title wrapping
        var legendTitleExtraHeight = legendTitleHeight - legendTitleDefaultHeight;

        if (legendTitleExtraHeight > 0) {
          var legendHeight = d3.select(this._container[0][0].childNodes[1])[0][0].offsetHeight - legendTitleExtraHeight;
          d3.select(this._container[0][0].childNodes[1]).style('height', legendHeight + 'px');
        }
      }
    }
  } else {
    this._addLegendItems();
  } // removes empty elements from inner chart svg
  // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md


  if (d3.select(".".concat(Classes.LEGEND, "-inner")).selectAll(".legend-item") !== null) {
    var arr = d3.select(".".concat(Classes.LEGEND, "-inner")).selectAll(".legend-item");

    if (typeof arr[0] !== 'undefined') {
      arr[0].forEach(function (gElem) {
        if (gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
          gElem.remove();
        } // for IE remove polyfill


        if (!gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
          Object.defineProperty(gElem, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
              if (this.parentNode !== null) this.parentNode.removeChild(this);
            }
          });
        }
      });
    }
  }
};
/**
 * @method makeSVGContainer
 * Create svg legend container
 * Includes width and height
 */


Legend.prototype.makeSVGContainer = function () {
  var legendWidth = this.get('legendWidth');
  var parentID = this.get('parentID');
  var textWidth = this._container.classed(Classes.LEGEND + '-right') ? legendWidth : this._container[0][0].offsetWidth - 20; // padding left + icon margin + icon width vertical

  var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

  if (this._legend[0][0] && legendHeight < this._legend[0][0].scrollHeight) {
    //Scrollbar space
    textWidth += 12;
  }

  this.set('legendWidth', textWidth);
  var svgHeight = legendHeight > this._data.length * 22 + 5 ? legendHeight : this._data.length * 22 + 5;
  var numHeight = this._container.classed(Classes.LEGEND + '-right') ? svgHeight : 20; // 17 line height + 5 padding

  var innerLegendSelector = document.querySelector("#svgcontainer_".concat(parentID));

  if (this._isScatterPlot()) {
    if (this._container.classed(Classes.LEGEND + '-right')) {
      d3.select(innerLegendSelector).style('padding-top', '5px');
      d3.select(innerLegendSelector).style('margin-top', '4px');
    }
  }

  if (this._container.classed(Classes.LEGEND + '-right')) {
    if (this._isScatterPlot() || this._isBubbleChart() || this._isVerticalBar() || this._isLineChart()) {
      var titleLabel = d3.select(innerLegendSelector).append('span').classed('mbc-legend-title', true).style('max-width', legendWidth - 15 + 'px').style('word-break', 'break-word'); // 15 for spacing to left of title

      titleLabel.html(this.get('legendTitle')); // If legendTitle is empty, negate default spacing

      if (!this._legendTitle) {
        titleLabel.style('display', 'inline');
        titleLabel.style('margin-left', '0px');
      }

      innerLegendSelector = d3.select(innerLegendSelector).append('div').attr('class', 'mbc-legend-svg').style('overflow', 'auto').style('overflow-x', 'hidden');
    }
  }

  if (this._options.chart === 'horizontalBar') {
    numHeight = 41;
    innerLegendSelector = document.querySelector("#svgcontainer_".concat(parentID)).children[0];
  }

  innerLegendSelector = innerLegendSelector[0] ? innerLegendSelector[0][0] : innerLegendSelector;
  var svg = d3.select(innerLegendSelector).append('svg').attr('role', 'legend').attr('class', 'mbc-legend').attr('height', numHeight + 'px');
  this.set('legendSVG', svg);
};

Legend.prototype.getDottedLines = function () {
  var arr = [].slice.call(this._data);
  var dotted = this.get('dottedLineNames');
  var lineStyles = {};
  arr.forEach(function (data, idx) {
    if (dotted) {
      var group = data.groupName;
      var name = data.displayName;
      var dottedLineNames = !(group === 'benchmark') ? dotted[group] : null;
      lineStyles[name] = dottedLineNames;
    }
  });
  this.set('lineStyles', lineStyles);
};
/**
 * @method drawSVGLegend
 * Adds legend items to svg container
 * Includes right and top positioning
 */


Legend.prototype.drawSVGLegend = function () {
  var y1Axis = this.get('axes').axis('y1') || this.get('axes').axis('y');

  this._clearPopoversOverlays();

  var legendSVG = this.get('legendSVG');
  var legendWidth = this.get('legendWidth');

  if (legendSVG[0][0].childNodes.length < 1) {
    this.set('legendfrontGroup', legendSVG.append('g').classed("".concat(Classes.LEGEND, "-inner"), true));
  }

  if (this._isTimeSeries()) {
    this._data = this._sortLegendData();
  }

  if (this._isBubbleChart()) this._data = this.get('benchmark') ? this._options.benchmark.concat(this._data) : this._data;

  if (this._isScatterPlot()) {
    var spData = this.get('data').get('scatterplot');

    this._color(0); //run colors to set scatterplotColors


    if (this.get('benchmark') && this._options.benchmark) {
      this._data = this._options.benchmark.concat(spData);
    }
  }

  var endPadding = legendWidth - 6; // SVG specific '7' - padding + borders

  var innerGroup = this.get('legendfrontGroup');
  var items = innerGroup.selectAll(".legend-item").data(this._data);
  var benchmarkColor = this.get('benchmarksColor') || this.get('benchmarkColor');
  var dottedBenchmark = this.get('dottedBenchmarks');
  var dottedLines = this.get('dottedLines');
  var colors = this.get('colors');
  var scatterColors = this.get('scatterplotColors');
  var showBenchmark = this.get('_showBenchmark') || this._isBubbleChart() && this.get('benchmark');
  var benchmarkLabel = this.get('benchmarkLabel');
  var legendWidth = this.get('legendWidth');
  var legendValuesFormat = this.get('legendValuesFormat');
  var legendShowValue = this.get('showLegendValues');
  var benchMarksVisible = this.get('benchMarksVisible');
  var parentID = this.get('parentID');
  var lineStyles = this.get('lineStyles');
  var chartType = this._options.chart;
  var benchmarksDataSource = this.get('benchmarksDataSource');
  var legendContainer = this.get('selection');
  var params = {
    _this: this,
    items: items,
    endPadding: endPadding,
    benchmarkColor: benchmarkColor,
    dottedBenchmark: dottedBenchmark,
    dottedLines: dottedLines,
    colors: colors,
    scatterplotColors: scatterColors,
    legendWidth: legendWidth,
    legendValuesFormat: legendValuesFormat,
    legendShowValue: legendShowValue,
    container: legendContainer,
    parentID: parentID,
    chartType: chartType,
    lineStyles: lineStyles,
    showBenchmark: showBenchmark,
    benchmarkLabel: benchmarkLabel,
    benchmarksDataSource: benchmarksDataSource
  };

  if (y1Axis || this._isBubbleChart()) {
    if (innerGroup && !this._isBubbleChart() && !this._isScatterPlot()) {
      innerGroup[0][0].setAttribute('transform', 'translate(0,1)');
    }

    if (this._container.classed(Classes.LEGEND + '-right')) {
      drawSVG.addItemsSVG(params);
      var id = this.get('popoverID');

      if (document.getElementById(id) !== null) {
        document.getElementById(id).parentElement.classList.remove('mbc-mds-popover__wrapper--visible');

        if (document.querySelector('[data-mbc-mds-popover="' + id + '"]') !== null) {
          document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'false');
        }
      }
    } else {
      if (this._isScatterPlot() || this._isBubbleChart()) {
        innerGroup.append('text').attr('class', 'mbc-legend-title').attr('x', 0).attr('y', 13).text(this._legendTitle);
      }

      if (this._options.chart !== 'horizontalBar') {
        drawSVG.addTopItemsSVG(params);
        this.createLegendPopoverSVG();
      }
    }
  }

  if (this._options.chart === 'horizontalBar') {
    this.get('selection').select('.mbc-chart-legend');
    params.legendFundName = this.get('legendFundName');
    params.legendBenchmarkName = this.get('legendBenchmarkName');
    params.benchmarkColor = this._options.benchmarkColor;
    var legendData = benchMarksVisible ? [{
      name: 'legendFundName',
      displayName: this.get('legendFundName')
    }, {
      name: 'legendBenchmarkName',
      displayName: this.get('legendBenchmarkName'),
      isBenchmark: true
    }] : [{
      name: 'legendFundName',
      displayName: this.get('legendFundName')
    }];
    params.items = innerGroup.selectAll(".legend-item").data(legendData);
    d3.select(innerGroup[0][0]).attr('transform', 'translate(0, 17)');
    drawSVG.addTopItemsSVG(params);
    this.createLegendPopoverSVG();
    var legendDivWidth = document.getElementById("svgcontainer_".concat(parentID)).clientWidth;
    d3.select(document.getElementById("svgcontainer_".concat(parentID)).children[0].children[0]).attr('width', legendDivWidth - 8); //set legend svg elem to legend div width
  }
};
/**
 * @method _clearPopoverWrapperOverlays
 * Removes existed popover wrappers and overlays
 */


Legend.prototype._clearPopoversOverlays = function () {
  if (document.getElementsByClassName('mbc-mds-popover__overlay').length != 0) {
    var overlays = document.getElementsByClassName('mbc-mds-popover__overlay');
    var arr = [].slice.call(overlays);
    arr.forEach(function (overlay) {
      overlay.parentElement.removeChild(overlay);
    });
  }

  if (document.getElementsByClassName('mbc-mds-popover').length != 0) {
    var popovers = document.getElementsByClassName('mbc-mds-popover');
    var arr = [].slice.call(popovers);
    arr.forEach(function (popover) {
      popover.parentElement.removeChild(popover);
    });
  }
};
/**
 * @method _addLegendItems
 * Add Items to legend container both benchmark and data
 * sets identifier and styles for items
 * maintains current chart specific css
 */


Legend.prototype._addLegendItems = function (container) {
  var _this = this;

  var enter;
  var mainDiv = container !== null && typeof container !== 'undefined' ? container : this._legend;
  var horizontalBarData = this.get('benchMarksVisible') ? [{
    name: 'legendFundName',
    displayName: this.get('legendFundName')
  }, {
    name: 'legendBenchmarkName',
    displayName: this.get('legendBenchmarkName')
  }] : [{
    name: 'legendFundName',
    displayName: this.get('legendFundName')
  }];
  var defaultLineStrokeWidth = 2;
  var marginTopConfigs = {
    2: 6,
    4: 5,
    6: 4
  };

  if (this.get('benchmark') && this._options.benchmark) {
    this._data = this._data[0] !== this.get('data').get('benchmark')[0] ? this.get('data').get('benchmark').concat(this._data) : this._data;
  }

  if (this._isTimeSeries()) {
    this._data = this._sortLegendData();
  }

  var isLineBenchmark = function isLineBenchmark(d) {
    return _this._isVerticalBar() && d.index === -1;
  };

  var isHorizontalBarBenchmark = function isHorizontalBarBenchmark(i) {
    return _this._options.chart === 'horizontalBar' && i === 1;
  };

  var isBenchmarkFirst = function isBenchmarkFirst(d) {
    return d.index === -1 && _this.get('_showBenchmark');
  };

  var lineStyle = function lineStyle(d) {
    var dottedLines = _this.get('dottedLines');

    var color = d.color || _this._color(d.index);

    var lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
    var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
    var style = lineIsDotted ? "2px dotted ".concat(color) : "".concat(lineStrokeWidth, "px solid ").concat(color);
    return style;
  };
  /**
   *  Similar to lineStyle() above but with different prop names and prop structure
   */


  var lineStyleForLine = function lineStyleForLine(d) {
    var dottedLines = _this.get('dottedLineNames');

    var axisData = d.name;

    var color = d.color || _this._color(d.index);

    var lineIsDotted = dottedLines[axisData] === true || Array.isArray(dottedLines[axisData]) && dottedLines[axisData].indexOf(d.displayName) > -1;
    var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
    var style = lineIsDotted ? "2px dotted ".concat(color) : "".concat(lineStrokeWidth, "px solid ").concat(color);
    return style;
  };

  var popOverData = this._options.chart === 'horizontalBar' ? horizontalBarData : this._data;
  enter = d3.select(mainDiv[0][0]).selectAll('div').data(popOverData).enter().append('div').attr('class', function (d) {
    return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
  }).classed('mbc-chart-legend-item', true);

  if (this._options.mouseover && this._options.chart !== 'horizontalBar') {
    enter.on('mouseover', function (d) {
      isBenchmarkFirst(d) ? _this.legendBenchmarkMouseover(d) : _this.legendMouseover(d);
    }).on('mouseout', function (d) {
      isBenchmarkFirst(d) ? _this.legendBenchmarkMouseout(d) : _this.legendMouseout(d);
    });
  }

  if (this._isTimeSeries() && this._container.classed(Classes.LEGEND + '-right')) {
    var legendValuesFormat = Utils.string.convertDashToEnDash(this.get('legendValuesFormat'));
    enter.append('p').attr('class', "".concat(Classes.LEGEND_ITEM, "__label--right")).text(function (d) {
      return d.displayName;
    }).style('border-top', function (d) {
      return lineStyle(d);
    }.bind(this));

    if (this.get('showLegendValues')) {
      enter.append('p').attr('class', "".concat(Classes.LEGEND_ITEM, "__value--right")).text(function (d) {
        return legendValuesFormat(d.value);
      });
    }
  } else {
    enter.append('span').classed(this._benchmarkSpan, function (d, i) {
      return isBenchmarkFirst(d) || isLineBenchmark(d);
    }).classed('horiz-bar-benchmark', function (d, i) {
      return isHorizontalBarBenchmark(i);
    }).classed("".concat(this._benchmarkSpan, "--dotted"), function (d) {
      return isLineBenchmark(d) && this._benchmarkStyle;
    }).classed("".concat(Classes.LEGEND_ITEM, "__key"), function (d) {
      return _this._isTimeSeries();
    }).classed("square", function (d, i) {
      return _this._isVerticalBar() && !isLineBenchmark(d) || _this._isScatterPlot() && isBenchmarkFirst(d) || _this._isBubbleChart() && isBenchmarkFirst(d) || _this._options.chart === 'horizontalBar' && i === 0;
    }).classed("circle", function (d) {
      return (_this._isScatterPlot() || _this._isBubbleChart()) && d.index !== -1;
    }).style('background-color', function (d, i) {
      if (_this._isTimeSeries()) {
        return 'transparent';
      }

      if (_this._isLineChart()) {
        return null;
      }

      if (isLineBenchmark(d) || isHorizontalBarBenchmark(i)) {
        return this._benchmarkStyle ? 'transparent' : this._benchmarkColor;
      }

      if (isBenchmarkFirst(d)) {
        return this._benchmarkColor;
      }

      if (this._isScatterPlot() || this._isBubbleChart()) {
        return this._color(d.groupIndex);
      }

      return !this._isDottedLine(d.groupName, d.displayName) ? this._color(i) : null;
    }.bind(this)).style('border-top', function (d, i) {
      if (_this._isLineChart()) {
        return null;
      }

      if (isLineBenchmark(d) && this._benchmarkStyle) {
        return "2px dotted ".concat(this._benchmarkColor);
      }

      return this._isDottedLine(d.groupName, d.displayName) ? "2px dotted ".concat(this._color(i)) : null;
    }.bind(this)).style('border-bottom', function (d) {
      if (_this._isTimeSeries()) {
        return lineStyle(d);
      }

      if (_this._isLineChart()) {
        return lineStyleForLine(d);
      }

      return null;
    }.bind(this)).style('margin-top', function (d) {
      if (_this._isTimeSeries() || _this._isLineChart()) {
        var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
        return "".concat(marginTopConfigs[lineStrokeWidth], "px");
      }

      return null;
    }.bind(this)).style('opacity', this.get('opacity'));
    enter.append('p').text(function (d) {
      return isBenchmarkFirst(d) && d.index === -1 ? _this._benchmarkLabel : d.displayName;
    });
  }
};
/**
 * @method generateID
 * Returns 5 digit id for legend popover created
 */


Legend.prototype.generateID = function () {
  return Math.floor(Math.random() * 90000) + 10000;
};
/**
 * @method addPopoverContent
 * Sets title and adds legend items to popover
 * @param id ID of popover generated at instantiation
 */


Legend.prototype.addPopoverContent = function (id) {
  var popOverElem = document.getElementById(id);

  if (popOverElem.getElementsByClassName("mbc-mds-popover__header").length !== 0) {
    var currentHeader = popOverElem.getElementsByClassName("mbc-mds-popover__header");
    currentHeader[0].parentNode.removeChild(currentHeader[0]);
  }

  if (popOverElem.getElementsByClassName("mbc-mds-popover__content").length !== 0) {
    var oldContent = popOverElem.getElementsByClassName("mbc-mds-popover__content");
    oldContent[0].parentNode.removeChild(oldContent[0]);
  }

  var headerElem = d3.select(popOverElem).append('header').attr('class', 'mbc-mds-popover__header');
  var titleElem = headerElem.append('h2').attr('class', 'mbc-mds-popover__title');
  titleElem[0][0].innerHTML = 'Legend';
  var contentElem = d3.select(popOverElem).append('div').attr('class', 'mbc-mds-popover__content').style('overflow', 'auto');
  var chartInners = document.getElementsByClassName('mbc-chart-inner');
  var chartTop = document.getElementsByClassName('mbc-chart-inner')[0].getBoundingClientRect().top;
  var arr = [].slice.call(chartInners);
  arr.forEach(function (inner) {
    if (d3.select(inner).attr('popoverID') == id) {
      chartTop = inner.getBoundingClientRect().top;
    }
  });
  var legendMax = window.innerHeight - chartTop - headerElem[0][0].clientHeight;
  var calcMax = legendMax - 120 < 120 ? 120 : legendMax - 120;
  var maxHeight = calcMax > 250 ? 250 : calcMax;
  contentElem[0][0].style.maxHeight = "".concat(maxHeight, "px"); //minus container bottom padding and title

  this._addLegendItems(contentElem);
};
/**
 * @method createOverlayDismiss
 * Adds popover overlay for dismissal
 * @param parentID ID of popover chart parent to get popover wrapper
 */


Legend.prototype.createOverlayDismiss = function (id) {
  var popoverParentSelector = this.get('legendPopoverParentElement');
  var popoverParent = document.querySelector(popoverParentSelector);

  if (popoverParent === null) {
    console.error("Chart parameter legendPopoverParentElement must be a class or id selector, invalid value is '".concat(popoverParentSelector, "'"));
  }

  var overLay = document.createElement('div');
  overLay.setAttribute('class', "mbc-mds-popover__overlay mbc-overlay_".concat(id));
  overLay.style.width = '100%';
  overLay.style.height = '100%';
  overLay.style.display = 'block';

  function removePopovers(e) {
    if (e.type === 'click' || e.type === 'keydown' && e.key.substr(0, 3).toLowerCase() === 'esc') {
      (function () {
        var popovers = document.querySelectorAll('.mbc-mds-popover'); // Close currently opened popovers outside of current selected

        var _loop = function _loop(m) {
          popovers[m].classList.remove('mbc-legend-popover--visible');
          popoverParent.removeChild(popovers[m]);
          var arr = [].slice.call(popovers[m].classList);
          arr.forEach(function (popOverClass) {
            if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
              var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);

              if (document.getElementsByClassName(chartClass)[0].children[0].classList.contains(Classes.LEGEND + '-top')) {
                document.querySelector('[data-mbc-mds-popover="' + popovers[m].id + '"]').setAttribute('aria-expanded', 'false');
              }
            }
          });
        };

        for (var m = 0; m < popovers.length; m++) {
          _loop(m);
        }

        popoverParent.removeChild(overLay);
      })();
    }
  }

  overLay.addEventListener('click', removePopovers, false);
  window.addEventListener('keydown', removePopovers, {
    once: true
  });
  popoverParent.appendChild(overLay);
};
/**
 * @method createLegendPopoverSVG
 * Build MDS popover using MDS icon see docs
 * http://designsystem.morningstar.com/components/popovers.html#css-class-references
 * http://designsystem.morningstar.com/visual-language/iconography.html
 */


Legend.prototype.createLegendPopoverSVG = function () {
  var id = this.get('popoverID');
  var parentID = this.get('parentID');

  var _this = this;

  var popoverParentSelector = this.get('legendPopoverParentElement');
  var popoverParent = document.querySelector(popoverParentSelector);

  this._container.style('overflow', 'visible');

  this._container.style('position', 'relative');

  if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
    document.querySelector('[data-mbc-mds-popover="' + id + '"]').parentNode.removeChild(document.querySelector('[data-mbc-mds-popover="' + id + '"]'));
  }

  var buttonTop = this._options.chart === 'horizontalBar' ? this._canvas.get('margin').top - 5 + 'px' : '1px';
  buttonTop = this._isBubbleChart() ? 0 : buttonTop;

  var buttonDiv = this._container.append('button').attr('class', 'mbc-mds-button mbc-mds-button--small mbc-mds-popover__trigger mbc-mds-button--icon-only').attr('type', 'button').attr('data-mbc-mds-popover', id).style('top', buttonTop).style('right', '6px').style('position', 'absolute').style('visibility', 'hidden').attr('aria-controls', id).attr('aria-haspopup', 'true').attr('aria-expanded', 'false');

  var btnImage = buttonDiv.append('svg').attr('class', 'mbc-mds-icon--s mbc-mds-button__icon');
  btnImage.attr('viewBox', '0 0 1500 1500').append('path').attr('d', 'M698.5 798.5h100v-100h-100v100zm-300 0h100v-100h-100v100zm350-800c-410 0-750 340-750 750s340 750 750 750 750-340 750-750-340-750-750-750zm0 1400c-360 0-650-290-650-650s290-650 650-650 650 290 650 650-290 650-650 650zm250-600h100v-100h-100v100z'); // draws ellipses icon from morningstar-design-system/dist/src/icons/ellipsis-circle--s.svg

  if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
    document.querySelector('[data-mbc-mds-popover="' + id + '"]').addEventListener('click', function () {
      var popOver = document.getElementById(id);

      if (popOver === null) {
        popOver = document.createElement('div');
        popOver.setAttribute('id', "".concat(id));
        popOver.setAttribute('class', "mbc-mds-popover mbc-mds-popover--width-200px mbc-mds-legend-popover_".concat(parentID));
        popOver.setAttribute('role', 'tooltip');
        popoverParent.appendChild(popOver);
      }

      _this.addPopoverContent(id);

      var popOverElem = document.getElementById(id);
      var popovers = document.querySelectorAll('.mbc-mds-popover');

      for (var m = 0; m < popovers.length; m++) {
        // Close currently opened popovers outside of current selected
        if (!popovers[m].isSameNode(popOverElem)) {
          popovers[m].classList.remove('mbc-legend-popover--visible');
          document.getElementsByClassName("".concat(parentID))[0].getElementsByClassName('mbc-mds-button--icon-only')[0].setAttribute('aria-expanded', 'false');
        }
      }

      var setPopover = _this.setPopoverPosition(id);

      setPopover.setPosition(popOverElem);
      popOverElem.classList.add('mbc-legend-popover--visible'); // Open currently selected popover

      document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'true');

      _this.createOverlayDismiss(id);
    });
  }

  this.showOverflowBtn(id);
};
/**
 * @method showOverflowBtn
 * Sets MDS popover wrapper to visible which shows only button in unselected state
 */


Legend.prototype.showOverflowBtn = function (id) {
  var parentID = this.get('parentID');
  var chartContainerElem = document.getElementsByClassName("".concat(parentID));
  var currentInner = chartContainerElem[0].getElementsByClassName('mbc-chart-legend-inner');
  var legendMaxWidth = chartContainerElem[0].childNodes[0].getBoundingClientRect().width;
  var legendContainerPadding = 20; // Padding between each legend item

  var legendContainerButtonLeftPadding = 50; // Left padding of the show/hide modal button

  var svgContainer = d3.select(chartContainerElem[0].childNodes[0].childNodes[0]);

  if (this._isScatterPlot() || this._isBubbleChart()) {
    var childNodes = currentInner[0].childNodes;
    var legendAvailableWidth = legendMaxWidth - legendContainerPadding - legendContainerButtonLeftPadding;

    for (var i = 0; i < childNodes.length; i++) {
      var childWidth = Utils.svg.getSVGTextWidth(svgContainer, childNodes[i].textContent, 'displayName');
      legendAvailableWidth = legendAvailableWidth - childWidth - legendContainerPadding;

      if (legendAvailableWidth < 0) {
        // Hide the legend item when no width is available
        childNodes[i].style.display = 'none';
      }
    }
  }

  if (currentInner[0].lastElementChild.style.display === 'none') {
    document.querySelector('[data-mbc-mds-popover="' + id + '"]').style.visibility = 'visible';
  }
};
/**
 * @method setPopoverPosition
 * Sets position of popovers on window scroll
 * Based on current overflow btn position and chart container position in window
 * @param id ID of popover generated at instantiation
 */


Legend.prototype.setPopoverPosition = function (id) {
  var _this = this;

  var parentID = this.get('parentID');
  var popoverWidth = 200;
  var currentPopover = document.getElementById(id);
  var popovers = document.querySelectorAll('.mbc-mds-popover');
  var chartContainerElem = document.getElementsByClassName("".concat(parentID));
  var iconBtns = document.querySelectorAll('.mbc-mds-popover__trigger');

  if (iconBtns.length > 0) {
    setPosition(currentPopover);

    window.onscroll = function () {
      var arr = [].slice.call(popovers);
      arr.forEach(function (popOverElem) {
        setPosition(popOverElem);

        if (!(popOverElem.getBoundingClientRect().top >= 0 || popOverElem.getBoundingClientRect().bottom >= 0) || !(popOverElem.getBoundingClientRect().left >= 0 || popOverElem.getBoundingClientRect().right >= 0)) {
          //if out of viewport then remove popover and overlay
          var popoverParentSelector = _this.get('legendPopoverParentElement');

          var popoverParent = document.querySelector(popoverParentSelector);
          var overLay = document.querySelector(".mbc-overlay_".concat(popOverElem.id));
          var popoverBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
          popOverElem.classList.remove('mbc-legend-popover--visible');
          popoverBtn.blur();
          popoverParent.removeChild(popOverElem);
          popoverParent.removeChild(overLay);
          popoverBtn.setAttribute('aria-expanded', 'false');
        }
      });
    };
  }

  function setPosition(popOverElem) {
    if (typeof popOverElem !== 'undefined' && popOverElem !== null) {
      var chartElem = chartContainerElem[0];
      var arr = [].slice.call(popOverElem.classList);
      arr.forEach(function (popOverClass) {
        if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
          var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
          chartElem = document.querySelector(".".concat(chartClass));
        }
      });

      if (popOverElem !== null && chartElem.children[0].classList.contains(Classes.LEGEND + '-top') || _this._options.chart === 'horizontalBar') {
        removePopoverPosition(popOverElem);
        var iconBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
        var bodyRect = document.body.getBoundingClientRect(),
            btnRect = iconBtn.getBoundingClientRect(),
            offsetTop = btnRect.top - bodyRect.top,
            offsetLeft = btnRect.left - bodyRect.left,
            popOverHeight = popOverElem.getBoundingClientRect().height;

        if (window.innerWidth - iconBtn.getBoundingClientRect().right >= popoverWidth) {
          //room on right of icon
          popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + 'px';
          popOverElem.style.left = offsetLeft + iconBtn.getBoundingClientRect().width + 'px';
          popOverElem.classList.add('mbc-mds-popover--right-bottom');
          return;
        }

        if (iconBtn.getBoundingClientRect().top >= popOverElem.getBoundingClientRect().height) {
          //room top of icon
          popOverElem.style.top = offsetTop - popOverHeight - iconBtn.getBoundingClientRect().height / 2 + 'px';
          popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + 'px';
          popOverElem.style.bottom = 'auto';
          popOverElem.classList.add('mbc-mds-popover--top-left');
          return;
        }

        popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height + 'px';
        popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + 'px';
        popOverElem.classList.add('mbc-mds-popover--bottom-left');
      }
    }
  }

  return {
    setPosition: setPosition
  };

  function removePopoverPosition(popOverElem) {
    popOverElem.removeAttribute('style');

    if (popOverElem.classList.contains('mbc-mds-popover--top-left')) {
      popOverElem.classList.remove('mbc-mds-popover--top-left');
    }

    if (popOverElem.classList.contains('mbc-mds-popover--bottom-left')) {
      popOverElem.classList.remove('mbc-mds-popover--bottom-left');
    }

    if (popOverElem.classList.contains('mbc-mds-popover--right-bottom')) {
      popOverElem.classList.remove('mbc-mds-popover--right-bottom');
    }

    if (popOverElem.classList.contains('mbc-mds-popover--left-bottom')) {
      popOverElem.classList.remove('mbc-mds-popover--left-bottom');
    }
  }
};
/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */


Legend.prototype.getLegendWidth = function (container, data) {
  var svg = container.append('svg');
  var width = Utils.svg.getGreaterSVGTextWidth(svg, data, 'displayName');
  svg.remove();
  return width;
};

Legend.prototype.getItemsWidth = function (container, data) {
  var svg = container.append('svg');
  var width = Utils.svg.getTotalSVGTextWidth(svg, data, 'displayName');
  svg.remove();
  return width;
};
/**
 * @method _setLegendHeightWidth
 * Set Legend width/height
 * Set Chart Container Width/Height
 * based on 'right' or 'top' attribute of legend container
 */


Legend.prototype._setLegendHeightWidth = function () {
  var chartContainer = this._canvas.get('container');

  var textWidth = this.getLegendWidth(this._container, this._data) + 15 + 6; // padding left + icon margin + icon width

  var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

  var marginLeft = 0;
  this.set('legendHeight', legendHeight);
  this.adjustLegendWidth(textWidth);

  if (!this._container.classed(Classes.LEGEND + '-right')) {
    //When legend is placed at top of chart
    legendHeight = this._container[0][0].offsetHeight;
    marginLeft = this.get('yAxisOrient') === 'left' ? this.get('yAxesLabelWidth') + this.get('yAxesLabelPadding') : 0;
    if (this._isBubbleChart()) marginLeft = this.checkViewIsGrid() ? marginLeft : 0;

    this._container.style('margin-left', marginLeft + 'px');

    if (this._data.length > 0 && this._data[0].groupName !== 'benchmark' && !this._isBubbleChart()) {
      var yAxesWidth = this.get('yAxesLabelWidth');

      if (this._isScatterPlot()) {
        yAxesWidth = this.get('yAxisOrient') == 'right' ? 0 : this.get('yAxesLabelWidth') + 2;
      }

      yAxesWidth = this._isVerticalBar() || this._options.chart === 'lineChart' ? this.axesLabelMarginValues() : yAxesWidth;

      this._container.style('margin-left', yAxesWidth + 'px');
    } else {
      var timeSeriesBottom = this._isTimeSeries() ? 2 : 0;
      if (!this._isBubbleChart()) d3.select(chartContainer).style('height', "calc(100% - ".concat(legendHeight - timeSeriesBottom, "px)"));

      if (this._isBubbleChart()) {
        var topLegendHeight = 20;
        if (this.checkViewIsGrid()) d3.select(chartContainer).style('height', "calc(100% - ".concat(topLegendHeight, "px)"));
      }
    }
  }

  this.set('legendContainer', this._container);
};
/**
 * @method axesLabelMarginValues
 * @desc determine axes layout return margin left of top legend
 * @return {Float}
 */


Legend.prototype.axesLabelMarginValues = function () {
  // one left, one right, one left/one right, two left, two right
  //vert-bar: left axis, no label || no label X top || show X labels || right axis || double axes no label || double axes left right || double axes right = 0
  if (this._isVerticalBar() && !this.get('y1AxisLabel') && this.get('y1AxisOrient') == 'left') return 0;
  if (this._isVerticalBar() && this.get('y1AxisOrient') == 'right') return 4;
  if (!this.get('y1AxisLabel') && !this.get('y2AxisLabel') && this.get('y1AxisOrient') == 'left' || this.get('y1AxisOrient') == 'right' && (this.get('y2AxisOrient') == 'right' || !this.get('y2'))) return 0;
  if (!this.get('y1AxisLabel') && this.get('y1AxisOrient') == 'right' && !this.get('y2')) return 3;
  if (this.get('y1AxisOrient') == 'right' || this.get('y2') && this.get('y2AxisOrient') == 'right' && this.get('y1AxisOrient') == 'right') return 4;
  return 15;
};
/**
 * @method adjustLegendHeight
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */


Legend.prototype.adjustLegendHeight = function () {
  var container = this.get('selection').selectAll('.' + Classes.LEGEND);
  var canvas = this.get('canvas');

  if (container.classed(Classes.LEGEND + '-right')) {
    var timeSeriesBottom = this._isTimeSeries() ? 2 : 0;
    container.style({
      height: canvas.height() + timeSeriesBottom + 'px'
    });
  }
};
/**
 * @method adjustLegendWidth
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */


Legend.prototype.adjustLegendWidth = function (textWidth) {
  var canvas = this._canvas;
  var parentID = this.get('parentID');
  var chartContainer = canvas.get('container');
  var scrollbarWithPadding = 19;
  var iconWidth = 40;
  var legendMarginPad = 13;
  var legendHeight = typeof this._container[0][0].children[0] !== 'undefined' ? this._container[0][0].children[0].clientHeight : this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

  if (this._container.classed(Classes.LEGEND + '-right')) {
    if (this._isBubbleChart()) {
      var legendContainerHeight = !this.checkViewIsGrid() ? canvas.height() + 20 : canvas.height() - 9;

      if (this._container[0][0].childNodes[1]) {
        legendContainerHeight = this.checkViewIsGrid() ? legendContainerHeight - 21 : legendContainerHeight;
        d3.select(this._container[0][0].childNodes[1]).style({
          height: legendContainerHeight + 'px'
        });
      }
    }

    var legendTitleMarginBottom = 5;
    var legendContainerMarginTop = 4;

    if (this._isScatterPlot()) {
      var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' && typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;
      var legendTitleHeight = this._container[0][0].children[0] && this._container[0][0].children[0].getBoundingClientRect().height || 0;
      var padding = 8; // Magic padding

      legendHeight = legendContainerMarginTop + legendTitleHeight + legendTitleMarginBottom + svgHeight + padding;
    } else if (this._isVerticalBar()) {
      var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' ? this._container[0][0].children[1].clientHeight : legendHeight;
      var padding = 1; // Magic padding

      legendHeight = svgHeight + padding;
    } else if (this._isBubbleChart()) {
      var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' && typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;

      var legendTitleHeight = this._container[0][0].children[0] && this._container[0][0].children[0].getBoundingClientRect().height;

      var padding = this.checkViewIsGrid() ? 4 : 3; // Magic padding

      var paddingTop = 9; // Bubble's special padding top style (MDS-11723)

      legendHeight = legendContainerMarginTop + legendTitleHeight + legendTitleMarginBottom + svgHeight + padding + paddingTop;
    } else if (this._isLineChart()) {
      var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' && typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;
      var padding = 6; // Magic padding

      legendHeight = svgHeight + padding;
    }

    var legendMaxWidth = this._legendMaxWidth;
    var legendMaxWidthWithScrollbar = 120 + scrollbarWithPadding; // This scrollbar present logic is slightly different from the logic in the scrollbarPresent() method in _svg.js

    if (legendHeight > this._container[0][0].offsetHeight) {
      textWidth = textWidth + scrollbarWithPadding;

      if (this._isTimeSeries()) {
        //show item line full width of container
        d3.select(this._container[0][0].children[0]).attr('width', (textWidth || 15) - 15);
      }
    }

    if (this._isScatterPlot() || this._isBubbleChart()) {
      var titleWidth = Utils.string.getTextWidth(this._legendTitle, 'Univers', '14px') + 15 + 6; // padding left + icon margin + icon width;

      textWidth = Math.max(textWidth, titleWidth);
      textWidth = Math.min(textWidth, legendMaxWidthWithScrollbar);
    }

    textWidth = textWidth > legendMaxWidth ? legendMaxWidth : textWidth;

    this._container.style('width', textWidth + 'px');

    var newLegendWidth = this.get('selection')[0][0].offsetWidth - textWidth - legendMarginPad;
    var chartWidth = this._isScatterPlot() ? newLegendWidth + 2 : newLegendWidth;
    d3.select(chartContainer).style('width', chartWidth + 'px');
    this.set('legendWidth', textWidth);

    if (!this._isScatterPlot() && this._data[0].groupName !== 'benchmark' && !this._isBubbleChart()) {
      var marginTop = this._isTimeSeries() ? canvas.get('margin').top - 2 : canvas.get('margin').top;

      this._legend.style('height', legendHeight + 'px');

      this._container.style({
        height: canvas.height() - 5 + 'px',
        //SVG Specific
        width: textWidth + 'px',
        'margin-top': marginTop + 'px' //SVG Specific

      });

      chartContainer = d3.select(canvas.get('container'));
      var chartWidth = chartContainer.node().clientWidth;
      var marginRight = this._isTimeSeries() && this.chartRightAxesNoLabel() ? 12 : 0; //calc was not working properly on IE 11, set width based on client instead

      chartContainer.style('width', "calc(100% - ".concat(textWidth + marginRight, "px)"));
    }
  } else {
    chartContainer = d3.select(canvas.get('container'));
    var chartWidth = chartContainer.node().clientWidth;

    if (this._isBubbleChart()) {
      chartContainer.style({
        width: '100%'
      });
    }

    d3.select("#svgcontainer_".concat(parentID)).select('svg').attr('width', chartWidth - iconWidth - 8); //overflow button - medium space
  }
};
/**
 * @method _color
 * Returns the index *n* color from the *colors* attribute array
 * @param {Number} index Index of color to return
 * scatterplot uses plot colors different array than colors
 * @return {Array}
 */


Legend.prototype._color = function (index) {
  var plotColors = this.get('plotColors');
  var colors = this.get('colors');

  if (plotColors) {
    if (!plotColors.length) {
      plotColors = [colors[0], colors[2]];
    }

    plotColors = plotColors.concat(colors.slice(3));
    this.set('scatterplotColors', plotColors);
    return plotColors[index % plotColors.length];
  }

  return colors[index % colors.length];
};
/**
 * @method _isDottedLine
 * Returns whether current key is dotted line
 * @param {String} group Chart group set
 * @param {String} name Current data value name
 * when adding legend item determines whether a {background-color, dotted line, or border} needed
 * @return {Boolean}
 */


Legend.prototype._isDottedLine = function (group, name) {
  if (this.get('dottedLineNames')) {
    var dottedLineNames = !(this._isScatterPlot(group) || group === 'benchmark') ? this.get('dottedLineNames')[group] : null;

    if (dottedLineNames instanceof Array) {
      return dottedLineNames.indexOf(name) > -1;
    } else {
      return dottedLineNames;
    }
  }

  return group === 'benchmark' && this._benchmarkStyle;
};
/**
 * @method _isScatterPlot
 * Returns whether chart option is scatterplot
 * @return {Boolean}
 */


Legend.prototype._isScatterPlot = function () {
  return this._options.chart === 'scatterplot';
};

Legend.prototype._isVerticalBar = function () {
  return this._options.chart === 'verticalBar';
};

Legend.prototype._isLineChart = function () {
  return this._options.chart === 'lineChart';
};

Legend.prototype._isTimeSeries = function () {
  return this._options.chart === 'time-series';
};
/**
 * @method _isBubbleChart
 * Returns whether chart option is bubbleChart
 * @return {Boolean}
 */


Legend.prototype._isBubbleChart = function () {
  return this._options.chart === 'bubbleChart';
};
/**
 * @method _isBenchmark
 * Returns whether current data is in benchmark group
 * @return {Boolean}
 */


Legend.prototype._isBenchmark = function (groupName) {
  return groupName === 'benchmark';
};
/**
 * @method sortLegendData
 * @param {Array} groups
 * @desc Takes an array of group names and creates a new data object sorted in descending order by value. This method is only used in Time-series Line chart.
 * @return {Array} sortedArray
 */


Legend.prototype._sortLegendData = function () {
  var dataManager = this.get('data');
  var sortedArr = [];

  var _this = this;

  var addLegendSet = function addLegendSet(group) {
    group.forEach(function (dataset) {
      var value = _this.getValidEndValue(dataset.series);

      var displayName = dataset.displayName,
          index = dataset.index,
          color = dataset.color,
          lineStrokeWidth = dataset.lineStrokeWidth;
      sortedArr.push({
        value: value,
        displayName: displayName,
        index: index,
        color: color,
        lineStrokeWidth: lineStrokeWidth
      });
    });
  };

  var y1DomainDataset = this.get('y1DomainDataset');
  var groups = [y1DomainDataset];

  if (this.get('y2')) {
    var y2DomainDataset = this.get('y2DomainDataset');
    groups = groups.concat(y2DomainDataset);
  }

  groups.forEach(function (name) {
    addLegendSet(dataManager.get(name));
  }); // sort legend items by the end value of series line

  sortedArr = this.sortDataByEndValue(sortedArr);
  return sortedArr;
};
/**
 * Set chart container width properly with no axes labels
 */


Legend.prototype.chartRightAxesNoLabel = function () {
  var y1LabelText = this.get('y1AxisLabel');
  var y2LabelText = this.get('y2AxisLabel');
  var y1Orient = this.get('y1AxisOrient');
  var y2Orient = this.get('y2AxisOrient');
  return y1Orient === 'right' && y2Orient !== 'right' && !y1LabelText || y1Orient !== 'right' && y2Orient === 'right' && !y2LabelText || y1Orient === 'right' && y2Orient === 'right' && !y2LabelText;
};
/**
 * Used to display the legend after having been removed
 */


Legend.prototype.addLegend = function () {
  if (this.get('showLegend') === false) {
    this.set('showLegend', true);
    this.update();
  }
};
/**
 * To remove the legend after having been rendered
 */


Legend.prototype.removeLegend = function () {
  this.set('showLegend', false);
  this.set('legendCreated', false);
  this.update();
};
/**
 * Mouse Listeners
 */


Legend.prototype.legendFocusIn = function (group) {
  this.get('legendContainer').selectAll(".legend-item").filter(function () {
    return !d3.select(this).classed(group);
  }).classed('unfocused', true);
};

Legend.prototype.legendFocusOut = function () {
  this.get('legendContainer').selectAll(".legend-item").classed('unfocused', false);
};

Legend.prototype.legendMouseover = function (d) {
  var group = Utils.string.dashify(d.name);
  var canvas = this.get('canvas');
  canvas.layer('chart-layer').selectAll('g.dot').filter(function () {
    return !d3.select(this).classed(group);
  }).classed({
    unfocused: true,
    less: true
  });
  canvas.layer(this.getId('benchmark'), 'front').select('rect').classed({
    unfocused: true
  });
  this.legendFocusIn(group);
};

Legend.prototype.legendMouseout = function () {
  var canvas = this.get('canvas');
  canvas.layer('chart-layer').selectAll('g.dot').classed({
    unfocused: false,
    less: false
  });
  canvas.layer(this.getId('benchmark'), 'front').select('rect').classed({
    unfocused: false
  });
  this.legendFocusOut();
};

Legend.prototype.getLegendWidth = function (container, data) {
  var svg = container.append('svg');
  var width = Utils.svg.getGreaterSVGTextWidth(svg, data, 'displayName');
  svg.remove();
  return width;
};

Legend.prototype.legendBenchmarkMouseover = function (d) {
  var canvas = this.get('canvas');
  canvas.layer('chart-layer').selectAll('g.dot').classed({
    unfocused: true,
    less: true
  });
  canvas.layer(this.getId('benchmark'), 'front').select('rect').classed({
    focused: true
  });
  this.legendFocusIn('benchmark');
};

Legend.prototype.legendBenchmarkMouseout = function () {
  var canvas = this.get('canvas');
  canvas.layer('chart-layer').selectAll('g.dot').classed({
    unfocused: false,
    less: false
  });
  canvas.layer(this.getId('benchmark'), 'front').select('rect').classed({
    focused: false
  });
  this.legendFocusOut();
};

module.exports = Legend;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(81);

__webpack_require__(97);

__webpack_require__(49);

__webpack_require__(84);

__webpack_require__(89);

__webpack_require__(117);

__webpack_require__(116);

__webpack_require__(40);

__webpack_require__(85);

var core = __webpack_require__(39);

var Utils = core.Utils;
/**
 * @method addItemsSVG
 * Creates svg items within legend on right side of chart
 * Key and Item name
 */

function addItemsSVG(params) {
  var names = [];
  var items = params.items;
  var firstPass;
  var lineHeight = 17;
  var keyPadding = 5;
  var linePadding = 3;
  var timeSeriesLinePadding = 13;
  var scatterplotYBuffer = 10;
  var timeSeriesNoValueLinePadding = 8;
  var defaultLineStrokeWidth = 2;
  var wrapVars = {
    params: params,
    container: params.container,
    names: names,
    firstPass: firstPass
  };
  var rangeLength = items.length * lineHeight + keyPadding; //line height + padding

  var y = d3.scale.linear().range([0, rangeLength]);

  var isLineChart = function isLineChart() {
    return params.chartType === 'lineChart';
  };

  var isTimeSeries = function isTimeSeries() {
    return params.chartType === 'time-series';
  };

  var isScatterPlot = function isScatterPlot() {
    return params.chartType === 'scatterplot';
  };

  var isBubbleChart = function isBubbleChart() {
    return params.chartType === 'bubbleChart';
  };

  var isBenchmark = function isBenchmark(d) {
    return d.groupName === params.benchmarksDataSource;
  };

  var isBenchmarkFirst = function isBenchmarkFirst(d) {
    return d.index === -1 && params.showBenchmark;
  };

  items.selectAll("*").remove();
  items.enter().append("g").attr("class", function (d) {
    return d.name ? Utils.string.dashify(d.name) : Utils.string.dashify(d.displayName);
  }).classed("legend-item", true);

  if (isTimeSeries()) {
    var additionalHeightConfigs = {
      2: 0,
      4: 2,
      6: 4
    };
    var additionalHeightForTopItem = 1; // Some oddity with the top legend item alignment

    var legendValuesFormat = Utils.string.convertDashToEnDash(params.legendValuesFormat);
    items.append("text").attr("class", function (d, i) {
      return "mbc-time-series_dataKey";
    }).attr("x", 0).text(function (d) {
      return d.displayName;
    }).call(wrap, wrapVars).attr("y", function (d, i) {
      var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
      var additionalHeight = lineStrokeWidth - additionalHeightConfigs[lineStrokeWidth];
      var yValue = y(i) + lineHeight + lineHeight * i;
      yValue = yValue + keyPadding * i;

      if (items[0][i - 1]) {
        var valueLine = params.legendShowValue ? linePadding / 2 * lineHeight : 5.5;
        yValue = getElementY(items[0][i - 1], 0) + getNumTspan(items[0][i - 1], params.chartType) * lineHeight + timeSeriesLinePadding + additionalHeight + valueLine;
      } else {
        // Top item
        yValue -= additionalHeightForTopItem;
      }

      return yValue;
    });

    if (params.legendShowValue) {
      items.append("text").attr("class", "mbc-time-series_dataValue").attr("x", 0).attr("y", function (d, i) {
        var yValue = y(i) + lineHeight * 2 + lineHeight * i;
        yValue = yValue + keyPadding * i + 3;

        if (items[0][i]) {
          yValue = getNumTspan(items[0][i], params.chartType) * lineHeight + linePadding + getElementY(items[0][i], 0);
        }

        return yValue;
      }).text(function (d) {
        names.push(legendValuesFormat(d.value));
        return legendValuesFormat(d.value);
      });
    }

    items.append("line").attr("x1", 0).attr("y1", function (d, i) {
      var yValue = y(i) + lineHeight * i;
      yValue = yValue + 5 * i;

      if (items[0][i - 1]) {
        var index = params.legendShowValue ? 1 : 0;
        var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
        yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index + timeSeriesLinePadding;
      }

      return yValue;
    }).attr("x2", function (d) {
      var svg = params.container.append("svg");
      var largestWidth = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + 21;
      svg.remove();
      var width = largestWidth - params.legendWidth >= 1 ? largestWidth : params.legendWidth - 1;
      return scrollbarPresent(wrapVars) ? width + 15 : width;
    }).attr("y2", function (d, i) {
      var yValue = y(i) + lineHeight * i;
      yValue = yValue + 5 * i;

      if (items[0][i - 1]) {
        var index = params.legendShowValue ? 1 : 0;
        var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
        yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index + timeSeriesLinePadding;
      }

      return yValue;
    }).attr("stroke", function (d) {
      return d.color || params.colors[d.index % params.colors.length];
    }).attr("stroke-dasharray", function (d) {
      var lineIsDotted = params.dottedLines.indexOf(d.displayName) > -1;
      return lineIsDotted ? "1 5" : "transparent";
    }).attr("stroke-linecap", "square").attr("stroke-width", function (d) {
      return d.lineStrokeWidth || defaultLineStrokeWidth;
    });
  } else {
    // Draw the text for all series and benchmark info
    items.append("text").attr("class", function (d, i) {
      return "dataName".concat(i);
    }).text(function (d) {
      if ((isScatterPlot() || isBubbleChart()) && d.index === -1) {
        return params.benchmarkLabel;
      }

      return d.displayName;
    }).attr("x", 15).call(wrap, wrapVars).attr("y", function (d, i) {
      var yValue = y(i) + 10;

      if (items[0][i - 1]) {
        yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) : yValue;
      }

      if (isScatterPlot() || isBubbleChart()) {
        var yValue = y(i);
        if (items[0][i - 1]) yValue = getNumTspan(items[0][i - 1]) > 4 ? getNumTspan(items[0][i - 1]) - 4 : yValue;
        if (i == 0) yValue = params.showBenchmark ? yValue = yValue + 15 : yValue + 12;
        return yValue;
      }

      return yValue;
    }).on("mouseover", function (d) {
      if (isScatterPlot() || isBubbleChart()) {
        return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseover.call(params._this, d, this) : params._this.legendMouseover.call(params._this, d, this);
      }

      return null;
    }).on("mouseout", function (d) {
      if (isScatterPlot() || isBubbleChart()) {
        return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseout.call(params._this, d, this) : params._this.legendMouseout.call(params._this, d, this);
      }

      return null;
    }); // Get the series without the benchmark

    var series = items.filter(function (d) {
      return d.groupName !== params.benchmarksDataSource;
    }); // Only draw the line for the line chart

    if (isLineChart()) {
      series.append("line").attr("x1", 0).attr("y1", function (d, i) {
        var yValue = y(i) + 5;

        if (items[0][i - 1]) {
          yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
        }

        return yValue;
      }).attr("x2", 10).attr("y2", function (d, i) {
        var yValue = y(i) + 5;

        if (items[0][i - 1]) {
          yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
        }

        return yValue;
      }).attr("stroke-width", function (d) {
        return d.lineStrokeWidth || defaultLineStrokeWidth;
      }).attr("stroke", function (d, i) {
        return d.color || params.colors[i % params.colors.length];
      }).attr("stroke-linecap", "square").attr("stroke-dasharray", function (d) {
        if (params.lineStyles[d.displayName]) {
          return "1 5";
        }
      });
    } // Only draw the rectangles for non-line charts like vertical-bar


    if (isScatterPlot() || isBubbleChart()) {
      // Get the series without the benchmark
      series = items.filter(function (d) {
        return params.showBenchmark ? d.index !== -1 : true;
      });

      if (params.showBenchmark) {
        d3.select(items[0][0]).append("rect").attr("x", 0).attr("y", function (d, i) {
          return y(i) + 4;
        }).attr("width", 10).attr("height", 10).attr("fill", params.benchmarkColor).attr("fill-opacity", 0.8).on("mouseover", function (d) {
          return params._this.legendBenchmarkMouseover.call(params._this, d, this);
        }).on("mouseout", function (d) {
          return params._this.legendBenchmarkMouseout.call(params._this, d, this);
        });
      }

      series.append("circle").attr("cx", 5).attr("cy", function (d, i) {
        if (params.showBenchmark) i = i + 1;
        var yValue = y(i);
        if (items[0][i - 1]) yValue = getNumTspan(items[0][i - 1]) > 10 ? getNumTspan(items[0][i - 1]) - 10 : yValue;
        if (i == 0) yValue = params.showBenchmark ? yValue = yValue + 15 : yValue + 7;
        return yValue;
      }).attr("r", 5).attr("fill", function (d, i) {
        if (isBubbleChart()) return d.color || params.colors[i % params.colors.length];
        return params.scatterplotColors[d.groupIndex % params.scatterplotColors.length];
      }).attr("fill-opacity", 0.8).on("mouseover", function (d) {
        return params._this.legendMouseover.call(params._this, d, this);
      }).on("mouseout", function (d) {
        return params._this.legendMouseout.call(params._this, d, this);
      });
    }

    if (!isScatterPlot() && !isLineChart() && !isBubbleChart()) {
      // Only draw the rectangles for non-line charts like vertical-bar
      series.append("rect").attr("x", 0).attr("y", function (d, i) {
        var yValue = y(i);

        if (items[0][i - 1]) {
          yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 10 : yValue;
        }

        return yValue;
      }).attr("width", 10).attr("height", 10).attr("fill", function (d, i) {
        return d.color || params.colors[i % params.colors.length];
      }).attr("fill-opacity", 0.8);
    }
  } // Draw Just Benchmark


  var benchmarkPosition = items[0].length - 2; //Needed to correctly position the benchmark line relative to the data point legend values

  var benchmark = items.filter(function (d) {
    return d.groupName === params.benchmarksDataSource;
  });

  if (!isTimeSeries()) {
    benchmark.append("line").attr("x1", 0).attr("y1", function (d, i) {
      var yValue = y(i) + 5;
      yValue = getNumTspan(items[0][benchmarkPosition]) > yValue ? getNumTspan(items[0][benchmarkPosition]) - 5 : yValue;
      return yValue;
    }).attr("x2", 10).attr("y2", function (d, i) {
      var yValue = y(i) + 5;
      yValue = getNumTspan(items[0][benchmarkPosition]) > yValue ? getNumTspan(items[0][benchmarkPosition]) - 5 : yValue;
      return yValue;
    }).attr("stroke", params.benchmarkColor).attr("stroke-width", "2");

    if (params.dottedBenchmark) {
      benchmark.attr("stroke-dasharray", "2,2");
    }
  }

  items.exit().remove();
  adjustSVGHeight(params, items);
  setLegendWidth(wrapVars);
}
/**
 * @method addTopItemsSVG
 * Creates svg items within legend on top of chart
 * Key and Item name
 * Hides elements that scope beyond chart width
 */


function addTopItemsSVG(params) {
  var items = params.items;
  var iconWithPadding = 16;
  var horizontalIconPadding = 5;
  var overflowBtnWithSpace = 24;

  var isBenchmark = function isBenchmark(d) {
    return d.groupName === params.benchmarksDataSource;
  };

  var isBenchmarkFirst = function isBenchmarkFirst(d) {
    return d.index === -1 && params.showBenchmark;
  };

  var isLineChart = function isLineChart() {
    return params.chartType === 'lineChart';
  };

  var isTimeSeries = function isTimeSeries() {
    return params.chartType === 'time-series';
  };

  var isHorizontalBar = function isHorizontalBar() {
    return params.chartType === 'horizontalBar';
  };

  var isVerticalBar = function isVerticalBar() {
    return params.chartType === 'verticalBar';
  };

  var isLineTime = function isLineTime() {
    return isLineChart() || isTimeSeries();
  };

  var isScatterPlot = function isScatterPlot() {
    return params.chartType === 'scatterplot';
  };

  var isBubbleChart = function isBubbleChart() {
    return params.chartType === 'bubbleChart';
  };

  items.enter().append("g").attr("class", function (d) {
    return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
  }).style("display", function (d, i) {
    var titleWidth;
    var svg = params.container.append("svg");
    var textWidth = Utils.svg.getSVGTextWidth(svg, d.displayName);
    var containerWidth = params.legendWidth;
    svg.remove();
    var benchmarkWidth = params.showBenchmark ? Utils.svg.getSVGTextWidth(params.container, params.benchmarkLabel) : 0;
    i = params.showBenchmark ? i + 1 : i;
    var textX = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName'); //item spacing + overflow button spacing and width

    var start = params.showBenchmark ? 1 : 0;

    if (isScatterPlot() || isBubbleChart()) {
      var titleNode = items[0].parentNode.childNodes[0];
      titleWidth = titleNode.getBoundingClientRect().width;
      var width = params.showBenchmark && i === 0 ? 0 : benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i - 1), 'displayName');
      textX = params.showBenchmark ? width : textX + benchmarkWidth;
      var prevItemWidth = width + (i - 1) * iconWithPadding + textWidth + iconWithPadding;
      textX = titleNode.className.baseVal === "mbc-legend-title" && titleWidth > 0 ? params.showBenchmark ? prevItemWidth + benchmarkWidth + 23 : textX + 40 : params.showBenchmark ? isBubbleChart() ? prevItemWidth + 13 : prevItemWidth + 21 : textX - 12;
      containerWidth = titleNode.className.baseVal === "mbc-legend-title" && titleWidth > 0 ? containerWidth - (isBubbleChart() && params._this.__attributes.view === null ? 40 : 20) : isBubbleChart() ? params.showBenchmark ? containerWidth - 40 : containerWidth : containerWidth - 8;
    }

    textX = params.showBenchmark ? textX + horizontalIconPadding : textWidth + textX + i * iconWithPadding + iconWithPadding + overflowBtnWithSpace;
    return textX > containerWidth ? "none" : "";
  }).classed("legend-item", true);

  if (isScatterPlot() || isBubbleChart()) {
    var benchmarkWidth = params.showBenchmark ? Utils.svg.getSVGTextWidth(params.container, params.benchmarkLabel) : 0;
    var titleNode = items[0].parentNode.childNodes[0]; // Get the series without the benchmark

    var series = items.filter(function (d) {
      return params.showBenchmark ? d.index !== -1 : true;
    });

    if (params.showBenchmark) {
      d3.select(items[0][0]).append("rect").attr("x", function (d, i) {
        var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');

        if (titleNode.className.baseVal === "mbc-legend-title") {
          var titleWidth = titleNode.getBoundingClientRect().width;
          width = titleWidth > 0 ? width + titleWidth + 15 : width;
        }

        if (i === 0) {
          return width;
        }

        return width + i * iconWithPadding;
      }).attr("y", function (d, i) {
        return iconWithPadding / 4;
      }).attr("width", 10).attr("height", 10).attr("fill", params.benchmarkColor).attr("fill-opacity", 0.8).on("mouseover", function (d) {
        return params._this.legendBenchmarkMouseover.call(params._this, d, this);
      }).on("mouseout", function (d) {
        return params._this.legendBenchmarkMouseout.call(params._this, d, this);
      });
    }

    series.append("circle").attr("cx", function (d, i) {
      var titleWidth;
      var start = 0;

      if (params.showBenchmark) {
        i = i + 1;
        start = 1;
      }

      var width = benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i), 'displayName');

      if (titleNode.className.baseVal === "mbc-legend-title") {
        titleWidth = titleNode.getBoundingClientRect().width;
        width = width + titleWidth;
      }

      if (i === 0) {
        return width > 0 ? width + 18 : width + horizontalIconPadding;
      }

      var prevItemWidth = width + i * iconWithPadding;
      return titleWidth > 0 ? params.showBenchmark ? prevItemWidth + 35 : prevItemWidth + 15 : params.showBenchmark ? prevItemWidth + iconWithPadding + horizontalIconPadding : prevItemWidth + horizontalIconPadding;
    }).attr("cy", function () {
      return iconWithPadding / 2;
    }).attr("r", 5).attr("fill", function (d, i) {
      if (isBubbleChart()) return d.color || params.colors[i % params.colors.length];
      return isBenchmarkFirst(d) ? "transparent" : params.scatterplotColors[d.groupIndex];
    }).attr("fill-opacity", 0.8).on("mouseover", function (d) {
      return params._this.legendMouseover.call(params._this, d, this);
    }).on("mouseout", function (d) {
      return params._this.legendMouseout.call(params._this, d, this);
    });
    items.append("text").attr("x", function (d, i) {
      var titleWidth;
      var start = params.showBenchmark ? 1 : 0;
      var width = params.showBenchmark && i === 0 ? 0 : benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i), 'displayName');

      if (titleNode.className.baseVal === "mbc-legend-title") {
        titleWidth = titleNode.getBoundingClientRect().width;
        width = width + titleWidth;
      }

      if (i === 0) {
        var prevItemWidth = width + iconWithPadding;
        return titleWidth > 0 ? params.showBenchmark ? prevItemWidth + 15 : prevItemWidth + 11 : prevItemWidth;
      }

      var prevItemWidth = width + i * iconWithPadding;
      return titleWidth > 0 ? params.showBenchmark ? prevItemWidth + 45 : prevItemWidth + 25 : params.showBenchmark ? prevItemWidth + iconWithPadding + horizontalIconPadding + 10 : prevItemWidth + iconWithPadding;
    }).attr("y", function () {
      return iconWithPadding - 3;
    }).text(function (d) {
      if (d.index === -1) {
        return params.benchmarkLabel;
      }

      return d.displayName;
    }).on("mouseover", function (d) {
      return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseover.call(params._this, d, this) : params._this.legendMouseover.call(params._this, d, this);
    }).on("mouseout", function (d) {
      return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseout.call(params._this, d, this) : params._this.legendMouseout.call(params._this, d, this);
    });
  }

  if (isHorizontalBar()) {
    items.attr("class", function (d) {
      var className = d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name); // Add 'benchmark-legend' class to the benchmark legend in Horizontal Bar

      var benchmarkLegendClass = ' benchmark-legend';
      return d.isBenchmark ? className + benchmarkLegendClass : className;
    });
    items.append("rect").attr("x", function (d, i) {
      var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
      return i === 0 ? width : width + (iconWithPadding - 3);
    }).attr("y", function (d, i) {
      return 0;
    }).attr("width", function (d, i) {
      return i === 1 ? 2 : 10;
    }).attr("height", function (d, i) {
      return 10;
    }).attr("fill", function (d, i) {
      if (i === 1) {
        return;
      }

      return params.colors[i % params.colors.length];
    }).attr("fill-opacity", function () {
      return 0.8;
    }).attr("stroke", function (d, i) {
      if (i === 0) {
        return;
      }

      return params.benchmarkColor;
    }).attr("stroke-width", "1");
    items.append("text").attr("x", function (d, i) {
      var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');

      if (i == 0) {
        return width + (iconWithPadding - 1);
      }

      return width + (iconWithPadding - 1) + horizontalIconPadding;
      ;
    }).attr("y", 10).text(function (d) {
      return d.displayName;
    });
  }

  if (!isHorizontalBar() && !isScatterPlot() && !isBubbleChart()) {
    items.append("rect").attr("x", function (d, i) {
      var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');

      if (i == 0) {
        return width;
      }

      return width + i * iconWithPadding;
    }).attr("y", function (d, i) {
      return isBenchmark(d, i) || isLineTime() ? 4 : 0;
    }).attr("width", function (d, i) {
      return 10;
    }).attr("height", function (d, i) {
      return isBenchmark(d, i) || isLineTime() ? 1 : 10;
    }).attr("fill", function (d, i) {
      if (isBenchmark(d, i) || isLineTime()) {
        return "none";
      }

      return params.colors[i % params.colors.length];
    }).attr("fill-opacity", function () {
      return isVerticalBar() ? 0.8 : 1;
    }).attr("stroke", function (d, i) {
      if (isLineChart()) {
        return d.color || params.colors[i % params.colors.length];
      }

      if (isTimeSeries()) {
        return d.color || params.colors[d.index % params.colors.length];
      }

      if (isBenchmark(d, i)) {
        return params.benchmarkColor;
      }

      return;
    }).attr("stroke-dasharray", function (d, i) {
      if (isTimeSeries() && params.dottedLines.indexOf(d.displayName) > -1) {
        return "3,3";
      }

      if (params.lineStyles[d.displayName] || isBenchmark(d, i) && params.dottedBenchmark) {
        return "3,3";
      }

      return;
    }).attr("stroke-width", function (d) {
      var defaultLineStrokeWidthForSmallLegend = "1";

      if (isTimeSeries() || isLineChart()) {
        return d.lineStrokeWidth || defaultLineStrokeWidthForSmallLegend;
      }

      return defaultLineStrokeWidthForSmallLegend;
    });
    items.append("text").attr("x", function (d, i) {
      var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');

      if (i == 0) {
        return width + (iconWithPadding - 1);
      }

      return width + i * iconWithPadding + (iconWithPadding - 1);
    }).attr("y", 10).text(function (d) {
      return d.displayName;
    });
  }

  items.exit().remove();
}
/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */


function getTotalItemsWidth(container, data, accessor) {
  var svg = container.append("svg");
  var width = Utils.svg.getTotalSVGTextWidth(svg, data, accessor);
  svg.remove();
  return width;
}
/**
 * @method getNumTspan
 * Gets number of lines text element wraps to
 * Line returns next line y-position
 * Time Series returns number of lines for element
 * @param element, @param chartType
 * @return {Number}
 */


function getNumTspan(element, chartType) {
  var numLines = 1;
  var prevY = getElementY(element, 0);

  if (typeof element !== 'undefined') {
    numLines = element.childNodes[0].childNodes.length;

    if (chartType === 'time-series') {
      return numLines > 1 ? numLines : 1;
    }
  }

  return numLines * 17 + prevY + 5;
}
/**
 * @method getElementY
 * Gets y attribute of elements child i
 * @param element, @param i
 * @return {Number}
 */


function getElementY(element, i) {
  return typeof element !== 'undefined' ? parseFloat(d3.select(element.childNodes[i]).attr("y")) : 0;
}
/**
 * @method wrap
 * Wraps text to multiple lines as needed according to legend width
 * @param text, @param container
 */


function wrap(text, wrapVars) {
  if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar' || wrapVars.params.chartType === 'lineChart') {
    var iconWithPadding = 14;
    var svgMaxWidth = 120;
    var svgLegendElement = wrapVars.params.container[0][0].children[1].children[1];
    var legendMaxWidth = Math.min(svgLegendElement.getBoundingClientRect().width, svgMaxWidth);
    var runningMaxWidth = legendMaxWidth;
    text.each(function () {
      var text = d3.select(this);
      var word = text.text();
      var x = text.attr("x");
      var y = text.attr("y");
      var tspan = text.text(null).append("tspan").attr("x", x).attr("y", y);
      var textWidth = Utils.string.getTextWidth(word, "Univers", "14px") + iconWithPadding;

      if (textWidth <= runningMaxWidth) {
        tspan.text(word);
      } else if (runningMaxWidth < svgMaxWidth && textWidth <= svgMaxWidth) {
        runningMaxWidth = textWidth;
        tspan.text(word);
      } else {
        runningMaxWidth = svgMaxWidth;
        var fragments = Utils.string.breakLegend(word, runningMaxWidth - iconWithPadding);
        tspan.text(fragments[0]);

        for (var i = 1; i < fragments.length; i++) {
          tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 + 0.25 + "em").text(fragments[i]);
          text.attr("id", "double");
        }
      }
    });
    wrapVars.runningMaxWidth = runningMaxWidth;
    return;
  } else {
    var legendMaxWidth = 120;
    var legendCurrentWidth = 120;

    if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar') {
      var SVGLegendElement = wrapVars.params.container[0][0].children[1].children[1];
      legendCurrentWidth = SVGLegendElement.getBoundingClientRect().width;
    }

    var scrollbarWidth = 17;
    var iconWithPadding = 21;
    text.each(function () {
      var text = d3.select(this),
          textWidth,
          words = text.text().split(/\s+/).reverse(),
          word,
          line = [],
          lineHeight = 1,
          // ems
      x = text.attr("x"),
          y = text.attr("y"),
          tspan = text.text(null).append("tspan").attr("x", x).attr("y", y),
          scrollbar = scrollbarPresent(wrapVars) ? scrollbarWidth : 0;
      var extraPadding = scrollbarPresent(wrapVars) ? scrollbarWidth : 0;
      /*
      // For each legend item:
      // * Find all the individual words that are wider than the legend max width
      // * Split them into fragments that will fit the width of the legend
      // * Insert the fragments in the correct order back into the array
      // * Let existing wrapping logic handle the rest.
      */

      var wordsArrayClone = words.slice();

      for (var i = 0; i < wordsArrayClone.length; i++) {
        var fragments;
        var indexOfWord;
        textWidth = Utils.string.getTextWidth(wordsArrayClone[i], 'sans-serif', '14px') + iconWithPadding + scrollbar;
        var legendDynamicWidth;

        if (wrapVars.params.chartType === 'bubbleChart') {
          // Expand the legend container width instead of wrapping the legend
          var totalTextWidth = textWidth + scrollbarWidth;
          legendDynamicWidth = legendCurrentWidth < legendMaxWidth && totalTextWidth < legendMaxWidth ? Math.max(legendCurrentWidth, totalTextWidth) : legendMaxWidth;
        } else {
          legendDynamicWidth = legendMaxWidth;
        }

        if (textWidth > legendDynamicWidth) {
          fragments = Utils.string.breakString(wordsArrayClone[i], textWidth, legendCurrentWidth).reverse();
          indexOfWord = words.indexOf(wordsArrayClone[i]);
          words.splice.apply(words, [indexOfWord, 1].concat(fragments));
        }
      }

      if (words.length < 2) {
        wrapVars.names.push(words[0]);
      }

      ;

      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(" "));
        wrapVars.firstPass = scrollbarPresent(wrapVars);
        var totalTSpanWidth;
        var legendDynamicWidth;

        if (wrapVars.params.chartType === 'bubbleChart') {
          totalTSpanWidth = tspan.node().getComputedTextLength() + iconWithPadding + scrollbarWidth; // Expand the legend container width instead of wrapping the legend

          legendDynamicWidth = legendCurrentWidth < legendMaxWidth && totalTSpanWidth < legendMaxWidth ? Math.max(legendCurrentWidth, totalTSpanWidth) : legendMaxWidth;
        } else if (wrapVars.params.chartType === 'verticalBar') {
          totalTSpanWidth = tspan.node().getComputedTextLength() + iconWithPadding + scrollbar + extraPadding;
          legendDynamicWidth = legendMaxWidth;
        } else {
          totalTSpanWidth = tspan.node().getComputedTextLength() + iconWithPadding + scrollbar;
          legendDynamicWidth = legendMaxWidth;
        }

        if (totalTSpanWidth > legendDynamicWidth && line.length > 1) {
          if (wrapVars.params.chartType === 'bubbleChart') {
            wrapVars.names.push(line.join(" "));
          }

          line.pop();
          tspan.text(line.join(" "));
          wrapVars.names.push(line.pop());
          line = [word];
          tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 * lineHeight + 0.25 + "em").text(word);
          text.attr("id", "double");
          wrapVars.names.push(word);
        } else {
          wrapVars.names.push(line.join(" "));
        }
      }
    });
  }
}
/**
 * @method adjustSVGHeight
 * Sets legend svg height according to last item in data
 * @param items
 * @return {Number}
 */


function adjustSVGHeight(params, items) {
  var parentID = params.parentID;
  var isTimeSeries = params.chartType === "time-series";
  var isBubbleChart = params.chartType === "bubbleChart";
  var isScatterPlot = params.chartType === "scatterplot";
  var lastElement = items[0][items[0].length - 1];
  var lastelemIndex = isTimeSeries && params.legendShowValue ? 1 : 0;
  var lastElementY = parseFloat(d3.select(lastElement.childNodes[lastelemIndex]).attr("y"));
  var lastElementH = lastElement.childNodes[lastelemIndex].getBoundingClientRect().height;
  var newLegendHeight = isTimeSeries ? lastElementH + lastElementY - 10 : lastElementH + lastElementY;
  var setLegendHeight = isBubbleChart ? newLegendHeight - 10 : newLegendHeight;
  setLegendHeight = isScatterPlot ? setLegendHeight - 15 : setLegendHeight;
  d3.select("#svgcontainer_".concat(parentID)).select("svg").attr("height", setLegendHeight);
}
/**
 * @method scrollbarPresent
 * Get Legend Height compare to chart height
 * 
 * Note this method doesn't always yield the correct result.
 * This is likely because some elements are not yet available
 * in DOM when this method is called.
 * 
 * @param container
 * @return {Number}
 */


function scrollbarPresent(wrapVars) {
  var svgLegendElement = wrapVars.params.container[0][0].children[1].getElementsByClassName("mbc-legend")[0];

  if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar') {
    var legendContainer = wrapVars.params.container[0][0].children[1];
    var legendTitleHeight = legendContainer.children[0].clientHeight;
    var padding = 18; // 5px margin top + 5px padding top + 5px padding bottom + 3px magic padding

    var svgaLegendElementMaxHeight = legendContainer.getBoundingClientRect().height - legendTitleHeight - padding;
    return svgLegendElement.clientHeight >= svgaLegendElementMaxHeight;
  }

  var legendContainerHeight = parseFloat(wrapVars.params.container[0][0].children[1].style.height);
  return legendContainerHeight <= svgLegendElement.clientHeight;
}
/**
* @method setLegendWidth
* Get Legend Width
* @param container, @param data
* @return {Number}
*/


function setLegendWidth(wrapVars) {
  var params = wrapVars.params;
  var parentID = params.parentID;
  var legendMaxWidth = 120;
  var scrollbarWidth = 17;
  var iconWithPadding = 21;
  var svg = params.container.append("svg");
  var width = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + iconWithPadding; // icon and padding

  svg.remove();

  if (scrollbarPresent(wrapVars)) {
    //Scrollbar space
    if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart') {
      var SVGLegendElement = wrapVars.params.container[0][0].children[1].children[1];
      var legendCurrentWidth = SVGLegendElement.getBoundingClientRect().width;
      width = width + scrollbarWidth < legendMaxWidth ? width : legendMaxWidth; // The width should not be smaller than current width

      width = Math.max(legendCurrentWidth, width);
    } else {
      width = width < legendMaxWidth - scrollbarWidth && params.chartType !== 'time-series' ? legendMaxWidth - scrollbarWidth : width;
    }
  }

  width = width > legendMaxWidth ? legendMaxWidth : width;

  if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar' || wrapVars.params.chartType === 'lineChart') {
    width = wrapVars.runningMaxWidth;
  }

  d3.select("#svgcontainer_".concat(parentID)).select("svg").attr("width", width);
}

module.exports = {
  addItemsSVG: addItemsSVG,
  addTopItemsSVG: addTopItemsSVG
};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAwIDE1MDAiPjxwYXRoIGQ9Ik02OTguNSA3OTguNWgxMDB2LTEwMGgtMTAwdjEwMHptLTMwMCAwaDEwMHYtMTAwaC0xMDB2MTAwem0zNTAtODAwYy00MTAgMC03NTAgMzQwLTc1MCA3NTBzMzQwIDc1MCA3NTAgNzUwIDc1MC0zNDAgNzUwLTc1MC0zNDAtNzUwLTc1MC03NTB6bTAgMTQwMGMtMzYwIDAtNjUwLTI5MC02NTAtNjUwczI5MC02NTAgNjUwLTY1MCA2NTAgMjkwIDY1MCA2NTAtMjkwIDY1MC02NTAgNjUwem0yNTAtNjAwaDEwMHYtMTAwaC0xMDB2MTAweiIvPjwvc3ZnPjwhLS0gbW9ybmluZ3N0YXItZGVzaWduLXN5c3RlbSB2MS4xNi4xIC0tPg=="

/***/ })
/******/ ]);
});